var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d6a76;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.45,21.83H5.55a3.38,3.38,0,0,1-3.38-3.38V5.55A3.38,3.38,0,0,1,5.55,2.17h12.9a3.38,3.38,0,0,1,3.38,3.38v12.9A3.38,3.38,0,0,1,18.45,21.83ZM5.55,3.67A1.88,1.88,0,0,0,3.67,5.55v12.9a1.88,1.88,0,0,0,1.88,1.88h12.9a1.88,1.88,0,0,0,1.88-1.88V5.55a1.88,1.88,0,0,0-1.88-1.88Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.21 15.73 5.07 14.76 8.84 10.34 12.98 13.47 17.34 7.66 18.54 8.56 13.28 15.58 9.06 12.39 6.21 15.73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityReportsIcon);
export default __webpack_public_path__ + "static/media/activity_reports_icon.b7500842966907d8e7f5cff76d9cfa9c.svg";
export { ForwardRef as ReactComponent };